module.exports = __webpack_public_path__ + "img/La_Provence_(logo).f6db46d2.svg";